'use client';

import { type NavbarDataProps, useNavbarItems } from '@/hooks/useNavbarItems';
import { Button, Collapse, Flex, Grid, Paper, ScrollArea } from '@mantine/core';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import type React from 'react';
import { useState } from 'react';
import { NavbarMenuMobile } from './NavbarMenuMobile';
export const NavbarMobile: React.FC = () => {
  const router = useRouter();
  const {
    values: mainItems
  } = useNavbarItems();
  const [activeItem, setActiveItem] = useState<NavbarDataProps | undefined>();
  const handleClickMainItem = (path: string) => {
    const active = mainItems.find(item => item.href === path);
    setActiveItem(active);
    active?.items ? active.onClick : router.push(path);
  };
  return <>
      <ScrollArea w="100%" type="never">
        <Paper mb={12} w={600} hiddenFrom="sm">
          <Flex direction="row" h="100%" justify="space-between">
            <NavbarMenuMobile handleMainClick={handleClickMainItem} />
          </Flex>
        </Paper>
      </ScrollArea>

      {activeItem && <Collapse in={!!activeItem.items?.length} mt={10} mb={20} hiddenFrom="sm">
          <Grid gutter={10}>
            {activeItem?.items?.map(item => <Grid.Col span={6} key={item.href}>
                <Button fullWidth component={Link} href={item.href || '#'} radius="sm" size="md" c="var(--text-dark)" fz={10} tt="uppercase" variant="gradient" gradient={{
            from: '#303942',
            to: '#464F59',
            deg: 135
          }}>
                  {item.label}
                </Button>
              </Grid.Col>)}
          </Grid>
        </Collapse>}
    </>;
};